import { useMemo } from 'react';
import { type CountryCode, countryCodes } from '../utils/countries-iso3166';

const countryNames = new Intl.DisplayNames([], { type: 'region' });

export function useCountries() {
  return useMemo(() => {
    const countries = countryCodes.map((code) => ({
      code,
      // biome-ignore lint/style/noNonNullAssertion: our list of country codes are ISO 3166, so should all have names from Intl.DisplayNames
      name: countryNames.of(code)!,
    }));
    countries.sort((a, b) => a.name.localeCompare(b.name));

    return countries;
  }, []);
}

export function useCountriesMap() {
  return useMemo(() => {
    const countriesMap: Record<string, string> = {};

    for (const code of countryCodes) {
      // biome-ignore lint/style/noNonNullAssertion: our list of country codes are ISO 3166, so should all have names from Intl.DisplayNames
      countriesMap[code] = countryNames.of(code)!;
    }

    return countriesMap as Record<CountryCode, string>;
  }, []);
}

export function getCountryName(countryCode: string) {
  return countryNames.of(countryCode);
}
